import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { Spinner } from '@treams/treams-ui';

import ListService, {
	ListServiceDateFormat,
} from '../../../kakapo-ui-services/services/common/ListService';
import ErrorStateCard from '../cards/ErrorStateCard';
import JourneyListEmptyState from './JourneyListEmptyState';
import { JourneyItem } from './JourneyListItem';
import JourneyListMonth, { createdTimestampFromJourneyItem } from './JourneyListMonth';

interface IProps {
	isViewer: boolean;
	items: Array<JourneyItem>;
	error: Error | null;
	isLoading: boolean;
}

export default function JourneyList({ isViewer, items, error, isLoading }: IProps) {
	const { t } = useTranslation();

	const sorted = ListService.reduceListToDateFormat(
		items
			// Sort on createdAt descending
			.sort((a, b) => {
				return (
					new Date(createdTimestampFromJourneyItem(b)).getTime() -
					new Date(createdTimestampFromJourneyItem(a)).getTime()
				);
			})
			.map((item) => ({
				...item,
				timestamp: moment(createdTimestampFromJourneyItem(item)).toDate(),
			})),
		ListServiceDateFormat.Month,
	);
	const sortedMonths = Object.keys(sorted).sort((a, b) => (a > b ? -1 : 1));

	return (
		<>
			{isLoading && (
				<Flex py={3}>
					<Spinner />
				</Flex>
			)}
			{!isLoading && (
				<>
					{error ? (
						<ErrorStateCard error={new Error(t('errors.somethingWentWrong'))} />
					) : (
						<>
							{sortedMonths.length === 0 ? (
								<JourneyListEmptyState isViewer={isViewer} />
							) : (
								sortedMonths.map((month, index) => (
									<JourneyListMonth
										key={moment(month, 'YYYY-MM').format('MMMM YYYY')}
										month={month}
										items={sorted[month]}
										nextMonthItemCount={
											sortedMonths[index + 1] ? sorted[sortedMonths[index + 1]].length : 0
										}
									/>
								))
							)}
						</>
					)}
				</>
			)}
		</>
	);
}
